export default __webpack_public_path__ + "static/media/gstock.66ab8c79.png";